import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

export const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  paddingTop: theme.spacing(1.5), // Reduced top padding
  paddingBottom: theme.spacing(1.5), // Increased bottom padding
  textAlign: "center",
  color: theme.palette.primary.text2,
  boxShadow: theme.shadows[3],
  borderRadius: 12,
  width: "100%", // Adjust width based on 'big' prop
  //height: '100%',
  margin: "auto", // Center the component
  ...theme.applyStyles("dark", {
    backgroundColor: theme.palette.background.default,
  }),
}));
